import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { Flex, Shimmer, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

const SaleBadge = styled(Flex).attrs((props) => ({
  alignItems: "center",
  bg: "ruby",
  borderRadius: props.sale ? "6px" : "2px",
  color: "white",
  display: "inline-flex",
  fontSize: "14px",
  fontWeight: "700",
  justifyContent: "center",
  letterSpacing: props.sale ? "1px" : "3px",
  lineHeight: "16px",
  mb: { tablet: "10px" },
  px: 1,
  py: "4px",
  textTransform: "uppercase",
  ...props,
}))``

const Badge = ({
  // holidayDelivery,
  onSale,
  prefStore,
  pricing,
  priorityBadge,
  wizardLoading,
}) => {
  if (wizardLoading || !prefStore || !Object.keys(pricing).length) {
    return <Shimmer height="24px" mb="10px" width="120px" />
  }

  if (priorityBadge) {
    return (
      <SaleBadge sale>
        <FontAwesomeIcon color="white" fontSize="16px" icon={faTag} mr="6px" />
        {priorityBadge.label}
      </SaleBadge>
    )
    // } else if (holidayDelivery) {
    //   return (
    //     <SaleBadge sale>
    //       {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}{" "}
    //       Delivery
    //     </SaleBadge>
    //   )
  } else if (onSale) {
    return <SaleBadge>SALE</SaleBadge>
  } else return null
}

Badge.propTypes = {
  // holidayDelivery: PropTypes.bool,
  onSale: PropTypes.bool,
  prefStore: PropTypes.bool,
  pricing: PropTypes.object,
  priorityBadge: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
    onSale: state.choices.sku && !!state.choices.sku.sale_price,
    prefStore: state.wizardUI.prefStore,
    pricing: state.wizardUI.currentPricing,
    priorityBadge: state.wizard.priorityBadge,
    wizardLoading: state.wizard.loading,
  }
}

export default connect(mapStateToProps)(Badge)
